import React from "react";
import { Avatar } from "../design/avatar";

interface UserGroupAvatarProps {
  users: { avatarUrl?: string; initials?: string }[];
  size?: number; // size of each avatar in pixels
}

const UserGroupAvatar: React.FC<UserGroupAvatarProps> = ({
  users,
  size = 32,
}) => {
  const overlap = Math.floor(size / 2); // less overlap = cleaner

  return (
    <div
      className="relative flex items-center"
      style={{
        width: size + (users.length - 1) * (size - overlap),
        height: size,
      }}
    >
      {users.slice(0, 3).map((user, index) => (
        <div
          key={index}
          className="absolute"
          style={{
            left: index * (size - overlap),
            zIndex: users.length + index,
          }}
        >
          <Avatar
            className="bg-gray-100 border-2 border-white rounded-full shadow-sm"
            src={user.avatarUrl}
            initials={user.initials}
            style={{ width: size, height: size }}
          />
        </div>
      ))}
      {users.length > 3 && (
        <div
          className="absolute flex items-center justify-center text-xs font-semibold text-gray-700 bg-gray-300 border-2 border-white rounded-full shadow-sm"
          style={{
            left: 3 * (size - overlap),
            width: size,
            height: size,
            zIndex: 0,
          }}
        >
          +{users.length - 3}
        </div>
      )}
    </div>
  );
};

export default UserGroupAvatar;
